module.exports = __webpack_public_path__ + "img/testimonialpanel1.82db30e6.jpg";